// removed by extract-text-webpack-plugin
module.exports = {"v2-input":"_1Dm6d","v2-input--column":"SdFxH","v2-input--disabled":"dG7Og","v2-input__icon":"_22sWV","v2-input__texts":"_1pTzx","v2-input__label":"_1Eo1j","v2-input__value":"_107cE","v2-input__right-icon":"_34PIg"};


//////////////////
// WEBPACK FOOTER
// ./src/components/V2/input/styles.module.css
// module id = 210
// module chunks = 0